import { DataStore } from "@aws-amplify/datastore";
import { Member } from "../models";
import { useDispatch } from "react-redux";
import { setError, setSearchResult } from "../features/search/slice";
import parseModel from "../util/parseModel";

export default function UseQueryMemberBy() {
  const dispatch = useDispatch();

  const memberById = async (prop) => {
    try {
      const members = await DataStore.query(Member, (member) =>
        member.studentId.eq(prop)
      );
      const result = parseModel(members);
      dispatch(setSearchResult(result));
    } catch (error) {
      console.error("Error retrieving members", error);
      dispatch(setError(toString(error)));
    }
  };

  return { memberById };
}
